import type { Agent } from "../sharedTypes";

// Events & Outages (cities, districts, events, ...) is built for Kibtek only.
const KIBTEK_DOMAIN = "kibtek";

const isKibtek = (user: Pick<Agent, "company_domain"> | null | undefined) =>
  user?.company_domain?.toLowerCase() === KIBTEK_DOMAIN;

export default isKibtek;
